
import {
  GET_ADDON_DT,
  GET_ADDON_DT_OK,
  GET_ADDON_DT_ERR,
  DO_ADDON_DT_CLEANUP,

  APPLY_ADDON_DT_FILTERS,
  PATCH_ADDON_DT_FILTERS,
  CLEAR_ADDON_DT_FILTERS,
  UNSET_ADDON_DT_FILTERS,
  DO_ADDON_DT_FILTERS_CLEANUP

} from './actionTypes';


/********** DATATABLE **********/

export const getAddOnDt = params => ({
  type: GET_ADDON_DT,
  payload: { params },
});

export const getAddOnDtOk = response => ({
  type: GET_ADDON_DT_OK,
  payload: { response },
});

export const getAddOnDtErr = error => ({
  type: GET_ADDON_DT_ERR,
  payload: { error },
});

export const doAddOnDtCleanup = () => ({
  type: DO_ADDON_DT_CLEANUP,
});

/********** DATATABLE FILTERS **********/

export const applyAddOnDtFilters = filters => ({
  type: APPLY_ADDON_DT_FILTERS,
  payload: { filters },
});

export const patchAddOnDtFilters = filters => ({
  type: PATCH_ADDON_DT_FILTERS,
  payload: { filters },
});

export const clearAddOnDtFilters = () => ({
  type: CLEAR_ADDON_DT_FILTERS,
});

export const unsetAddOnDtFilters = () => ({
  type: UNSET_ADDON_DT_FILTERS,
});

export const doAddOnDtFiltersCleanup = () => ({
  type: DO_ADDON_DT_FILTERS_CLEANUP,
});
